import React from 'react'
import Media from './components/Media'
import Navbar from './components/Navbar'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from './components/Dashboard';
import Games from './components/Games';
import Podcast from './components/Podcast';
import QuizApp from './QuizApp'
import FooterMain from './components/FooterMain'

export default function App() {
  return (
    <div>  
 
<Router>

    <Navbar/>


    <Routes>
                  <Route exact path="/" element={<Dashboard />} />
                  <Route path="/music" element={<Media/>} />
                  <Route path="/games" element={<Games/>} />
                  <Route path="/podcast" element={<Podcast/>} />
                  {/* <Route path="/quiz" element={<QuizApp/>} /> */}


                  

                </Routes>

      
                <FooterMain/>

</Router>

<br />
<br />
    </div>
  )
}
